var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-topprogress',{ref:"topProgress"}),_c('div',{staticClass:"min-h-screen flex flex-col bb-view-background"},[_c('PermissionCheck',{attrs:{"permission":"drg.app.header.view"}},[_c('Header')],1),_c('div',{staticClass:"mx-auto w-full bb-max-width px-4 flex flex-col pt-6 pb-6 flex-1"},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }